/*
 * @Description: 项目配置
 * @Date: 2021-03-22 00:21:31
 */

import runConfig from '@Config/run_config.json';

export const TOKEN_KEY = 'authentication';

export const REQUEST_PATH = '';

export const REQUEST_DOMAIN = runConfig['env'].PROXY;

export const XCX_PATH = runConfig['env'].XCX_DOMAIN;

/**
 * 当前平台当前环境的小程序 appid（各平台各环境不同，_config/{平台}/config.json env.XCX_APPID）
 */
export const XCX_APPID = runConfig['env'].XCX_APPID;

/**
 * 小程序版本（准入二维码落库用）：构建环境 → 微信 env_version
 * dev→develop（开发版）/ test|pre→trial（体验版）/ prod→release（正式版）
 */
const ENV_VERSION_MAP = {
  dev: 'develop',
  test: 'trial',
  pre: 'trial',
  prod: 'release'
} as const;

export const ENV_VERSION =
  ENV_VERSION_MAP[
    (runConfig['envKey'] ?? 'test') as keyof typeof ENV_VERSION_MAP
  ] ?? 'trial';

export const FILE_VIEW_URL =
  'https://oss.myxrk.com/myxrk-v2/front-end/html/file-view/index.html';

export const SUN_WEB_URL = process.env.VUE_APP_SUN_URL;

export const BI_URL = runConfig['env'].BI_DOMAIN + process.env.VUE_APP_BI_PATH;

export const REPORT_URL =
  runConfig['env'].BI_DOMAIN + process.env.VUE_APP_REPORT_PATH;

export const QQ_MAP_KEY = 'ZXVBZ-4333V-RT3PJ-UQYHY-SIBIQ-BHFTU';

export const PLATFORM_TYPE = runConfig['platform-type'] as 1 | 2; // 平台类型，区分1向日葵平台、2独立平台

export const IS_PLATFORM_TYPE_1 = PLATFORM_TYPE === 1;

export const IS_PLATFORM_TYPE_2 = PLATFORM_TYPE === 2;

export const PLATFORM_ID = runConfig['platform-id']; // 平台\独立平台 ID，用于全局请求头，比如三个独立项目PLATFORM_TYPE都为2，id不同，可能为101、102、103

export const PLATFORM_IS_FEIGON = runConfig['platform-id'] === 2001; //飞冠（飞冠例外 走经营没劳务只有技术服务费）

export const PLATFORM_IMAGES = runConfig['images']; // 平台\独立平台 图片地址 logo 登录页背景图等

export const PLATFORM_NAME = runConfig['project-name']; // 平台\独立平台 名称
export const APP_USER_AGREEMENT_NAME = runConfig['user-agreement-name'];

export const IS_ASSISTANT = PLATFORM_ID === 9001; // 向日葵服务助手
